// extracted by mini-css-extract-plugin
export default {"call-to-action":"CallToAction_call-to-action__2OUJF","background":"CallToAction_background__XR7Oe","theme-grayscale":"CallToAction_theme-grayscale__Z7WwN"};